interface IParams {
  [key: string]: string;
}

const convertParamsToUrl = (params: { [key: string]: unknown }) => {
  const nonArrayFields: IParams = {};

  const arrayFields = Object.entries(params).reduce<{ [key: string]: unknown[] }>(
    (acc, [key, value]) => {
      if (Array.isArray(value)) {
        acc[key] = value;
      } else {
        nonArrayFields[key] = String(value);
      }

      return acc;
    },
    {},
  );

  const paramsToUrl = new URLSearchParams(nonArrayFields);

  Object.entries(arrayFields).forEach(([key, value]) => {
    // @ts-ignore
    value.forEach((arrayValue: IParams) => paramsToUrl.append(`${key}[]`, String(arrayValue)));
  });

  return paramsToUrl;
};

export default convertParamsToUrl;
